export default import.meta.ROLLDOWN_FILE_URL_t0_xAETWdch1hivv_wzSmA